import React from 'react'
import { useTranslation } from 'react-i18next'
import { useGetCode } from './GetCode.hooks'
import { BannerRotator } from 'cityads-v3/types/bannerRotator'
import { ExclusiveUnion } from 'cityads-v3/types/utils'
import classes from './GetCode.scss'

import Button from '@mui/material/Button'
import CopyText from 'cityads-v3/components/CopyText/CopyText'
import CopyTextField from 'cityads-v3/components/CopyTextField/CopyTextField'
import SelectField from 'cityads-v3/components/TextField/SelectField'
import WidgetHider from 'cityads-v3/components/WidgetHider/WidgetHider'

export type GetCodeProps = ExclusiveUnion<{ id: number } | { bannerRotator: BannerRotator }>
  & {
    buttons?: JSX.Element
  }

type CodeVariant = keyof Pick<BannerRotator, 'async_embed_code' | 'embed_code'>

export default function GetCode({ id, bannerRotator, buttons }: GetCodeProps): JSX.Element {
  const { t } = useTranslation(['BannerRotator', 'main'])

  const {
    form,
    typeList,
    bannerRotatorById
  } = useGetCode()

  const code = (bannerRotator ?? bannerRotatorById?.[id])?.[form.fields.type.value as CodeVariant] ?? '';

  return (
    <div className={classes.form}>
      <WidgetHider variant="mobile" />
      <SelectField<string, string>
        label={t('codeType')}
        items={typeList}
        handleChange={form.fields.type.setValue}
        value={form.fields.type.value}
      />

      <CopyTextField
        multiline
        label={t('code')}
        maxRows={3}
        value={code}
      />

      <div className={classes.buttons}>
        {buttons}

        <CopyText copyText={code} component="span">
          <Button
            color="primary"
            variant="contained"
          >{t('main:buttons.copy')}</Button>
        </CopyText>
      </div>
    </div>
  )
}
